module.exports = __webpack_public_path__ + "img/category_sea__and__beach.d26786d.png";